import { PlusOutlined } from '@ant-design/icons';
import { Button, Dropdown, Flex } from 'antd';
import { useCallback, useContext } from 'react';

import { config } from '@app/config';
import { RIGHTS_MODULES } from '@app/constants';
import { useNewUserAccessRights } from '@app/hooks';
import { IntegrationsContext } from '@app/providers';
import { selectAccessRights, useAppSelector } from '@app/store';

import { DropdownItems } from '@pages/Integrations/IntegrationsList/components/DropdownItems';
import { ExportIntegrationLogButton } from '@pages/Integrations/IntegrationsList/components/ExportIntegrationLogButton';

import { useIntegrationsPageHeader } from '@pages/Integrations/IntegrationsList/hooks';

export const IntegrationsPageHeader = () => {
  const { label, IsCreate, navigateToYooKassaAccessRightPage } =
    useIntegrationsPageHeader();

  const accessRights = useAppSelector(selectAccessRights);
  const hasRightToAddWhatsAppIntegrations = accessRights?.[
    RIGHTS_MODULES
  ]?.find((item: { RightType: number }) => item.RightType === 6);

  const {
    userAccessRights: {
      Warehouse: { IsOn },
    },
  } = useNewUserAccessRights();

  const {
    isExportLogVisible,
    setIsSocialMediaSettingsModalOpen,
    setCurrentIntegrationType,
    setIsEmailModalOpen,
    setIsAtcModalOpen,
    setIsOpenAddWhatsAppIntegrationWarningModal,
    setIsAdd1CIntegrationModalOpen,
  } = useContext(IntegrationsContext);

  const create1CIntegration = useCallback(() => {
    setIsAdd1CIntegrationModalOpen(true);
  }, [setIsAdd1CIntegrationModalOpen]);

  const items = DropdownItems({
    setIsSocialMediaSettingsModalOpen,
    setCurrentIntegrationType,
    setIsEmailModalOpen,
    hasRightToAddWhatsAppIntegrations:
      hasRightToAddWhatsAppIntegrations?.Allowed,
    setIsAtcModalOpen,
    setIsOpenAddWhatsAppIntegrationWarningModal,
    navigateToYooKassaAccessRightPage,
    show1CIntegration: IsOn,
    create1CIntegration,
    isMaxIntegrationBlocked: config.isMaxIntegrationBlocked,
  });

  // Кнопка выгрузки журнала живёт здесь же, на одной строке с «Добавить
  // интеграцию» (us/11024). Права на создание она не требует: выгрузка нужна
  // и тому, кто интеграции только чинит.
  return (
    <Flex gap={8} align="center">
      <ExportIntegrationLogButton isVisible={isExportLogVisible} />

      {IsCreate && (
        <Dropdown menu={{ items }} placement="bottomLeft">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            data-testid="add-integration"
          >
            {label}
          </Button>
        </Dropdown>
      )}
    </Flex>
  );
};
